
import { BoxMonitorViewPage } from "./view.box";
import { CloudMonitorViewPage } from "./view.cloud";
import { DemoMonitorViewPage } from "./view.demo";

import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default class WebMonitorView extends mixin(environment.nexus, {
  box: BoxMonitorViewPage,
  cloud: CloudMonitorViewPage,
  demo: DemoMonitorViewPage,
}) {
  [key: string]: any;
  searching = false;

  onSearchToggle() {
    this.searching = !this.searching;
  }
}
